import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewWorkflow: {
		id: 'issue-field-status.common.view-workflow.button.view-workflow',
		defaultMessage: 'View workflow',
		description: 'Footer action item to view the workflow in the status view dropdown',
	},
});
